<template></template>

<script setup>
import { computed } from "vue";
import { useHead } from "@unhead/vue";

const props = defineProps({
  meta: {
    type: Object,
    default: () => ({
      seo: {},
      seoImage: {},
    }),
  },
});
const imgPath = computed(() => {
  if (props.meta.seoImage && props.meta.seoImage.filename) {
    return props.meta.seoImage.filename.replace("https://a.storyblok.com/", "");
  } else {
    return false;
  }
});
const imgService = "https://img2.storyblok.com/";
const imgOptions = "1200x627/smart/filters:format(jpg)/";

const seoImage = computed(() => {
  if (imgPath.value) {
    return imgService + imgOptions + imgPath.value;
  } else {
    return "fallback image";
  }
});

const title = computed(() => {
  return props.meta.seo.title ? `${props.meta.seo.title} - Isabella Capobianco` : "Isabella Capobianco";
});

useHead({
  title: title,
  meta: [
    {
      name: "description",
      content: props.meta.seo.description,
    },
    {
      property: "og:title",
      content: title,
    },
    {
      property: "og:description",
      content: props.meta.seo.description,
    },
    {
      property: "og:image",
      content: seoImage.value,
    },
  ],
});
</script>

<style lang="scss" scoped></style>
